import {ProductProps} from "./Product";
import React from "react";

export const ProductNameContainer = ({product}: ProductProps) => {
    return (
        <div className="lg:col-span-5 lg:col-start-8">
            <div className="flex justify-between">
                <h1 className="text-xl font-medium text-gray-900">{product.title}</h1>
                <p className="text-xl font-medium text-gray-900">89,99zł</p>
            </div>
        </div>
    );
}